export default class StickyButton {
    constructor() {
        this.$root = document.querySelector('.js-sticky-button');
        if (!this.$root) return;

        this.$close = this.$root.querySelector('.js-sticky-button__close');
        if (!this.$close) return;

        this.showAfter = 120;
        this.isClosed = false;

        this.$close.addEventListener('click', (e) => {
            e.preventDefault();
            this.isClosed = true;
            this.$root.style.display = 'none';
        });

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    }

    onScroll() {
        if (this.isClosed) return;
        if (window.scrollY <= this.showAfter) return;

        this.$root.classList.add('-reveal');
        window.removeEventListener('scroll', this.onScroll, { passive: true });
    }
}
